import classes from './LoginContainer.module.css'

const LoginContainer = ({children}) => {
    return(
        <div className={`d-flex justify-content-center ${classes.wrapper}`}>{children}</div>
    )
}

export default LoginContainer